module.exports = __webpack_public_path__ + "img/11.36873c7c.png";